export const profileTh = {
    firstname: {
        name: 'ชื่อ',
        placeholder: 'ชื่อ',
        required: 'กรุณากรอกชื่อ',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'นามสกุล',
        placeholder: 'นามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: '',
        invalid: '',
    },
    contactnumber: {
        name: 'เบอร์โทรศัพท์',
        placeholder: 'เบอร์โทรศัพท์',
        required: 'กรุณากรอกเบอร์โทรศัพท์',
        too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
        invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    },
    email: {
        name: 'อีเมล',
        placeholder: 'อีเมล',
        required: 'กรุณากรอกอีเมล',
        too_short: '',
        invalid: 'อีเมลไม่ถูกต้อง',
    },
    idCard: {
        name: 'เลขบัตประชาชน',
        placeholder: 'เลขบัตประชาชน',
        required: 'กรุณากรอกเลขบัตประชาชน',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'รหัสผ่าน',
        placeholder: 'รหัสผ่าน',
        required: 'กรุณากรอกรหัสผ่าน',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'เพศ',
        placeholder: '',
        required: 'กรุณาเลือกเพศ',
        too_short: '',
        invalid: '',
        defaultText: 'กรุณาเลือก',
    },
    birthdate: {
        date: {
            name: 'วัน',
            defaultText: 'วัน',
            required: ''
        },
        month: {
            name: 'เดือน',
            defaultText: 'เดือน',
            required: ''
        },
        year: {
            name: 'ปี',
            defaultText: 'ปี',
            required: ''
        },
    },
}
